import { render, staticRenderFns } from "./ModalEditName.vue?vue&type=template&id=13175d9c&scoped=true&"
import script from "./ModalEditName.vue?vue&type=script&lang=js&"
export * from "./ModalEditName.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditName.vue?vue&type=style&index=0&id=13175d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13175d9c",
  null
  
)

export default component.exports